import { Key, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import { RiArrowLeftSLine } from 'react-icons/ri';

import { AuthContext, useAuth } from 'context/AuthContext';

import ArticlePlaceholder from 'components/ui/article-placeholder';

import Box from 'components/ui/box';
import { getPlayerInfo, getServerTime, getTasks, getTotalTasks } from 'services/dashboard.service';
import { TaskItem } from 'components/task-item';

import ImgFeedback from 'assets/img/comportamento/bg-missoes-not-found.png';
import Button from 'components/ui/button';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { BsPlusLg } from 'react-icons/bs';
import { BiMinus } from 'react-icons/bi';
import CustomSelect from 'components/custom-select';
import Detail from './Detail';
import { subMinutes } from 'date-fns';
import { format } from 'date-fns-tz';
import { NotFound } from 'pages/NotFound';
import { GetVersion } from 'services/utils';

// const cycles = [new Date('2022-11-18'), new Date('2022-12-18')];
// const cyclesStatus = ['PERÍODO DE AVALIAÇÃO', 'ENVIAR ENTREGAS'];
// const currentCycle = 1;

export default function MissaoDestaque() {
  const { user, realCycle, cycleSelected, setCycleSelected } = useAuth();
  const navigate = useNavigate();

  const [realDatetime, setRealDatetime] = useState<number>(0);

  const [playerInfo, setPlayerInfo] = useState<any>();
  const [isGestor, setIsGestor] = useState<boolean | undefined>();
  const [totalTasks, setTotalTasks] = useState<{ total: number; total_participation: number; can_register: boolean }>({
    total: 0,
    total_participation: 0,
    can_register: false,
  });
  const [loading, setLoading] = useState(true);
  const [myTasks, setMyTasks] = useState<any[]>();
  const [otherTasks, setOtherTasks] = useState<any[]>();
  const [allTasks, setAllTasks] = useState<any[]>();

  const [taskCycles, setTaskCycles] = useState<any>();
  const [taskCyclesAll, setTaskCyclesAll] = useState<any>();

  const [tab, setTab] = useState<'cadastrada' | 'participando'>('cadastrada');
  const [cycleActive, setCycleActive] = useState<string>();
  const [showMore, setShowMore] = useState(false);
  const [numberOfElements, setNumberOfElements] = useState(3);
  const [optionsCycle, setOptionsCycle] = useState<any[] | undefined>([]);
  const [activeItem, setActiveItem] = useState<any>();
  const [showDetail, setShowDetail] = useState(false);

  function handleClickCreate() {
    navigate('./cadastrar');
  }

  useEffect(() => {
    let interv: any = undefined;

    getServerTime().then(timestamp => {
      setRealDatetime(timestamp);

      interv = window.setInterval(() => {
        setRealDatetime(prevstate => prevstate + 1000);
      }, 1000);
    });

    return () => clearInterval(interv);
  }, []);

  const activeCycleObj = useMemo(() => {
    if (cycleActive === 'semestral') {
      const cycle = realCycle?.find(x => x._id === cycleSelected?._id);

      const evaluationStage = taskCycles.find((x: any) => x.status === 'open' || x.status === 'evaluation') || taskCycles[0];
      if (!evaluationStage || !cycle?.date_start || !cycle?.date_end) return undefined;

      const _stages = {
        ...evaluationStage,
        title: 'Semestral',
        date_start: cycle?.date_start,
        date_finish: cycle?.date_end,
        step: 5,
        // taskStep >= 5 getTaskStep
      };

      return _stages;
    }

    if (cycleActive === 'trimestral') {
      const evaluationStage = taskCycles.find((x: any) => x.status === 'open' || x.status === 'evaluation') || taskCycles[0];
      if (!evaluationStage || !evaluationStage?.date_trimester_start || !evaluationStage?.date_trimester_finish) return undefined;

      const _stages = {
        ...evaluationStage,
        title: 'Trimestral',
        date_start: evaluationStage?.date_trimester_start,
        date_finish: evaluationStage?.date_trimester_finish,
        step: 4,
        // taskStep >= 4 getTaskStep
      };

      return _stages;
    }

    return taskCycles?.find((item: any) => item._id === cycleActive);
  }, [cycleActive, cycleSelected?._id, realCycle, taskCycles]);

  const activeStageObj = useMemo(
    () =>
      taskCycles?.find((item: any) => item.status === 'open' || item.status === 'evaluation') ||
      (taskCycles?.length && taskCycles[0]),
    [taskCycles],
  );

  const tasksPerCycle: any = useMemo(() => {
    if (!Array.isArray(myTasks) || !Array.isArray(otherTasks) || !taskCycles?.length || !cycleActive) return null;

    const tasks = [...(tab === 'cadastrada' ? myTasks : otherTasks)];

    return tasks?.length ? tasks : [];
  }, [cycleActive, myTasks, otherTasks, tab, taskCycles]);

  const resumePerCycle: {
    registered: number;
    validated: number;
    waiting: number;
  } | null = useMemo(() => {
    if (!Array.isArray(myTasks) || !Array.isArray(otherTasks) || !taskCycles?.length || !cycleActive) return null;

    const cycle = taskCycles.find((cycle: any) => cycle._id === cycleActive);
    const tasks = [...(tab === 'cadastrada' ? myTasks : otherTasks)]?.filter(
      item => item.created >= cycle?.date_start && item?.created <= cycle?.date_finish,
    );

    return {
      registered: tasks.length || 0,
      validated: tasks?.filter(task => !!task.status?.match(/(aprovado|dobrado|promovido|selo|concluido)/gi))?.length || 0,
      waiting: tasks?.filter(task => !!task.status?.match(/(aguardando)/gi))?.length || 0,
    };
  }, [cycleActive, myTasks, otherTasks, tab, taskCycles]);

  const getActiveEvaluationStep: 0 | 2 | 3 | 4 | 4.1 | 5 | null = useMemo((): 0 | 2 | 3 | 4 | 4.1 | 5 | null => {
    if (!activeCycleObj || activeCycleObj.status !== 'evaluation' || !realDatetime) return null;

    if (realDatetime > activeCycleObj.date_evaluation_step2_start && realDatetime < activeCycleObj.date_evaluation_step2_finish) {
      // Etapa 2
      return 2;
    } else if (
      realDatetime > activeCycleObj.date_evaluation_step3_start &&
      realDatetime < activeCycleObj.date_evaluation_step3_finish
    ) {
      // Etapa 3
      return 3;
    } else if (
      realDatetime > activeCycleObj.date_evaluation_step4_start &&
      realDatetime < activeCycleObj.date_evaluation_step4_finish
    ) {
      // Etapa 4
      return 4;
    } else if (
      realDatetime > activeCycleObj.date_evaluation_pitStop_start &&
      realDatetime < activeCycleObj.date_evaluation_pitStop_finish
    ) {
      // Pit Stop
      return 4.1;
    } else if (
      realDatetime > activeCycleObj.date_evaluation_step5_start &&
      realDatetime < activeCycleObj.date_evaluation_step5_finish
    ) {
      // Etapa 5
      return 5;
    } else {
      return 0;
    }
  }, [activeCycleObj, realDatetime]);

  const taskEditable = useCallback(
    (task: any): boolean => {
      if (!activeCycleObj || !user) return false;

      if (tab === 'cadastrada' && task.owner === user._id) {
        if (
          task.status === 'aguardando' &&
          activeCycleObj.status === 'open' &&
          task.created >= activeCycleObj.date_start &&
          task.created <= activeCycleObj.date_finish
        ) {
          return true;
        }

        if (
          task.status === 'rejeitado' &&
          getActiveEvaluationStep &&
          getActiveEvaluationStep === 2 &&
          task.created >= activeCycleObj.date_start &&
          task.created <= activeCycleObj.date_evaluation
        ) {
          return true;
        }

        return false;
      }

      return false;
    },
    [activeCycleObj, getActiveEvaluationStep, tab, user],
  );

  function renderTasksPerCycle() {
    if (!resumePerCycle) return null;

    try {
      if (tasksPerCycle?.length) {
        return tasksPerCycle.map((task: { _id: Key | null | undefined; owner: string | undefined; status: string }) => (
          <div key={task._id}>
            <TaskItem
              data={task}
              editable={taskEditable(task)}
              onDelete={() => loadData()}
              onReload={() => loadData()}
              cycle={activeCycleObj}
              playerInfo={playerInfo}
            />
          </div>
        ));
      }
    } catch (e) {
      return null;
    }
  }

  function translate(total: number) {
    switch (total) {
      case 3:
        return 'três';
      case 2:
        return 'dois';
      default:
        return '';
    }
  }

  function renderCreateTaskPerCycle() {
    if (!resumePerCycle) return null;

    // if (tab === 'cadastrada' && !totalTasks?.can_register && (!myTasks?.length || myTasks?.length < 1))
    //   return (
    //     <div className="flex justify-center items-center flex-col space-y-2 lg:space-y-8 bg-maastricht-blue-3 rounded-[20px] p-8 text-center">
    //       <p className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
    //         <strong className="block text-center text-yellow font-semibold text-xl">
    //           {/* Você{activeCycleObj?.status === 'open' ? ' ainda' : ''} não foi incluído em Ações ECOA de outros */}
    //           Você já foi incluído no número máximo de Realizações Destaque de outros colegas!
    //         </strong>
    //       </p>
    //     </div>
    //   );

    if (
      (tab === 'cadastrada' && myTasks?.length && myTasks?.length >= 1) ||
      activeCycleObj?.status !== 'open' ||
      (tab === 'participando' && otherTasks && otherTasks?.length >= 1)
    )
      return;

    return (
      <div className="flex justify-center items-center flex-col space-y-2 lg:space-y-8 bg-maastricht-blue-3 rounded-[20px] p-8 text-center">
        <img src={ImgFeedback} className="max-w-[150px]" alt=" " />
        {tab === 'cadastrada' && (
          <>
            {cycleActive !== 'semestral' && cycleActive !== 'trimestral' ? (
              <>
                <p className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
                  <strong className="block text-center text-yellow font-semibold text-xl">
                    Que tal cadastrar uma realização destaque nesta fase?
                  </strong>
                  Cadastre sua Realização Destaque, seja reconhecido pela liderança e ganhe recompensas! <br />
                  Lembre-se: você só pode cadastrar 1 realização neste mês (fase). <br />
                  <b>Atenção</b>: só devem ser cadastradas realizações <b>concluídas</b>.
                </p>
              </>
            ) : (
              <>
                <p className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
                  <strong className="block text-center text-yellow font-semibold text-xl">
                    Não existem realizações apreciadas até o momento.
                  </strong>

                  {cycleActive === 'semestral' && (
                    <span>As Realizações são apreciadas trimestralmente e enviadas para etapa de avaliação semestral.</span>
                  )}

                  {cycleActive === 'trimestral' && (
                    <span>As Realizações são apreciadas mensalmente e enviadas para etapa de avaliação trimestral.</span>
                  )}
                </p>
              </>
            )}
          </>
        )}
        {tab === 'participando' && (
          <>
            {cycleActive !== 'semestral' && cycleActive !== 'trimestral' ? (
              <>
                <p className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
                  <strong className="block text-center text-yellow font-semibold text-xl">
                    {/* Você{activeCycleObj?.status === 'open' ? ' ainda' : ''} não foi incluído em Realizações Destaque de outros */}
                    Você ainda não foi incluído em Realizações Destaque de outros colegas!
                  </strong>
                  Caso tenha colaborado em alguma Realização de outra equipe, verifique com seus colegas a possibilidade de ser
                  indicado.
                </p>
              </>
            ) : (
              <>
                <p className="text-lg block text-center font-thin text-white leading-loose tracking-tight">
                  <strong className="block text-center text-yellow font-semibold text-xl">
                    Não existem realizações apreciadas até o momento.
                  </strong>

                  {cycleActive === 'semestral' && (
                    <span>As Realizações são apreciadas trimestralmente e enviadas para etapa de avaliação semestral.</span>
                  )}

                  {cycleActive === 'trimestral' && (
                    <span>As Realizações são apreciadas mensalmente e enviadas para etapa de avaliação trimestral.</span>
                  )}
                </p>
              </>
            )}
          </>
        )}

        {/* {tab === 'cadastrada' && user?.extra?.task !== false && cycleActive !== 'semestral' && cycleActive !== 'trimestral' ? (
          <button
            className="text-alice-blue bg-slate-blue text-sm flex items-center justify-center font-semibold uppercase hover:ring hover:ring-white ring-2 ring-slate-blue rounded py-3 px-10"
            onClick={() => handleClickCreate()}
          >
            Cadastrar Realização Destaque
          </button>
        ) : null} */}
      </div>
    );
  }

  useEffect(() => {
    if (taskCycles?.length) {
      const currentCycle = taskCycles?.find((item: any) => item.status === 'open');
      setCycleActive(currentCycle?._id || taskCycles[0]._id);
    }
  }, [tab, taskCycles]);

  // useEffect(() => {
  //   console.log('tasksPerCycle', tasksPerCycle);
  //   console.log('resumePerCycle', resumePerCycle);
  // }, [tasksPerCycle, resumePerCycle]);

  async function loadData() {
    if (!realCycle?.[0]) return;

    let playerInfoResult: any;
    if (!playerInfo) {
      playerInfoResult = await getPlayerInfo(user?._id);

      setPlayerInfo(playerInfoResult);
    } else {
      playerInfoResult = { ...playerInfo };
    }

    // const _totalTasks: any = await getTotalTasks();

    // setTotalTasks({
    //   total: _totalTasks?.total | 0,
    //   total_participation: _totalTasks?.total_participation | 0,
    //   can_register: _totalTasks?.can_register,
    // });

    const _isGestor =
      (!!playerInfoResult?.cod_etapa && playerInfoResult?.cod_etapa > 0 && playerInfoResult?.cod_etapa <= 5) ||
      (typeof playerInfoResult?.mad_dupla_cod_etapa === 'number' &&
        playerInfoResult?.mad_dupla_cod_etapa > 0 &&
        playerInfoResult?.mad_dupla_cod_etapa <= 5);
    setIsGestor(_isGestor);

    if (_isGestor) {
      setTab('participando');
    }

    const data = await getTasks(user?._id, activeCycleObj.date_start, activeCycleObj.date_finish, false, activeCycleObj.step);

    const my_tasks = data.filter((item: any) => item.owner === user?._id && item.status !== 'arquivado');
    const other_tasks = data.filter((item: any) => item.owner !== user?._id && item.status !== 'arquivado');

    setMyTasks(my_tasks);
    setOtherTasks(other_tasks);
    setAllTasks([...my_tasks, ...other_tasks]);
    setLoading(false);
  }

  useEffect(() => {
    if (!realCycle) return;

    const cycleOptions = realCycle.map((cycle: any) => {
      cycle.label = 'Ciclo ' + cycle.title;
      cycle.value = cycle._id;

      return cycle;
    });

    setOptionsCycle(cycleOptions);

    if (!activeItem) {
      setActiveItem(cycleOptions.find(x => x.value === cycleSelected?._id) ? cycleSelected?._id : cycleOptions[0].value);
      setTaskCyclesAll(realCycle.filter((item: any) => item.year > 2022));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [realCycle]);

  useEffect(() => {
    if (!user || !realCycle || !taskCycles || !activeCycleObj) return;

    setLoading(true);

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, realCycle, taskCycles, activeCycleObj]);

  useEffect(() => {
    if (!taskCycles) return;

    if (taskCycles.length <= numberOfElements) {
      setShowMore(false);
    } else {
      setShowMore(true);
    }
  }, [numberOfElements, taskCycles]);

  useEffect(() => {
    if (!activeItem) return;

    const filtredData = taskCyclesAll?.filter((item: any) => item._id === activeItem);

    if (!!filtredData?.length) {
      setTaskCycles(filtredData[0].steps);
    }
  }, [activeItem, taskCyclesAll]);

  function getIndexByValue(array: any, value: string) {
    return array.findIndex((element: any) => element.value === value);
  }

  if (!user || typeof isGestor !== 'boolean') return null;

  // if (isGestor && !loading) {
  //   return (
  //     <div className="mx-auto container p-4 lg:p-10">
  //       <div className="flex flex-row items-center space-x-4 mb-16">
  //         <div>
  //           <Link to="../">
  //             <button className="rounded-full bg-purple flex justify-center items-center p-1">
  //               <RiArrowLeftSLine size={28} className="text-white" />
  //             </button>
  //           </Link>
  //         </div>
  //         <h1 className="text-xl lg:text-3xl text-white font-semibold">Realização Destaque</h1>
  //       </div>

  //       <div className="border-2 border-electric-blue rounded-3xl p-8 bg-oxford-blue">
  //         <p className="text-dandelion text-lg font-semibold block text-center">Você não possui acesso à esta página.</p>
  //       </div>
  //     </div>
  //   );
  // }

  if (showDetail) return <Detail onClose={() => setShowDetail(false)} />;

  if (user.extra.rede) return <NotFound />;

  return (
    <>
      <div className="mx-auto container p-4 lg:p-10">
        <div className="flex flex-row items-center space-x-4 mb-16">
          <div>
            <Link to="../">
              <button className="rounded-full bg-purple flex justify-center items-center p-1">
                <RiArrowLeftSLine size={28} className="text-white" />
              </button>
            </Link>
          </div>
          <h1 className="text-xl lg:text-3xl text-white font-semibold">Realização Destaque</h1>
        </div>

        <div className="border-2 border-electric-blue rounded-3xl p-8 mb-12 bg-oxford-blue">
          <p className="text-dandelion text-lg font-semibold block mb-3">Como funciona a dinâmica Realização Destaque?</p>
          <p className="text-white text-base font-light m-0">
            Essa dinâmica visa estimular a colaboração e valorizar a contribuição dos funcionários para o alcance dos diversos
            objetivos do Banco por meio da possibilidade de apreciação e reconhecimento de suas entregas pela liderança das
            unidades. <br />
            <br />
            Cadastre e descreva detalhadamente sua realização mais relevante do mês. Ela será apreciada pelos seus líderes e todos
            os participantes poderão receber pontos,
            <em className="italic">feedbacks</em> e <strong className="font-semibold">Selo Realização Destaque</strong>.
          </p>
        </div>

        <div className="rounded-xl overflow-hidden hidden lg:flex items-center justify-between mb-12">
          {!isGestor && (
            <button
              className={`${
                tab === 'cadastrada' ? 'bg-slate-blue' : 'bg-maastricht-blue'
              } w-6/12 h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center hover:opacity-80 transition-opacity`}
              onClick={() => (!loading ? setTab('cadastrada') : null)}
            >
              Realização Destaque cadastrada
            </button>
          )}
          <button
            className={`${tab === 'participando' ? 'bg-slate-blue' : 'bg-maastricht-blue'} ${
              isGestor ? 'w-full' : 'w-6/12'
            }  h-[86px] text-2xl text-white border-0 font-semibold flex items-center justify-center hover:opacity-80 transition-opacity`}
            onClick={() => (!loading ? setTab('participando') : null)}
          >
            Participação em Realizações Destaque
          </button>
        </div>

        <div className="flex justify-between items-center lg:hidden mb-10">
          <Button
            color="clear"
            className="shadow-none pr-0 pl-0"
            disabled={tab === 'cadastrada'}
            onClick={() => setTab('cadastrada')}
          >
            <IoIosArrowBack className={`text-grey-dark ${tab === 'cadastrada' && 'opacity-5'}}`} size={24} />
          </Button>

          <p className="text-xl font-bold text-yellow">
            {tab === 'cadastrada' ? 'Realização Destaque cadastrada' : 'Participação em Realizações Destaque'}
          </p>

          <Button
            color="clear"
            className="shadow-none pr-0 pl-0"
            disabled={tab === 'participando'}
            onClick={() => setTab('participando')}
          >
            <IoIosArrowForward className={`text-grey-dark ${tab === 'participando' && 'opacity-5'}}`} size={24} />
          </Button>
        </div>

        <div className="w-full flex flex-col lg:flex-row lg:justify-between">
          <div className="lg:w-[32.5%]">
            <div className="mb-5">
              <h2 className="text-xl text-white block mb-6 font-semibold">Histórico de Realizações Destaque</h2>

              <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px]">
                {loading ? (
                  <div className="grid grid-cols-1 gap-3">
                    <ArticlePlaceholder />
                  </div>
                ) : (
                  <>
                    <div className="px-8 mb-8">
                      <div>
                        <p className="mb-2">Escolha o ciclo que deseja acompanhar</p>

                        {optionsCycle && (
                          <div className="mb-4">
                            <CustomSelect
                              placeholder="Clique para selecionar o ciclo"
                              options={optionsCycle}
                              onChange={(e: any) => {
                                setActiveItem(e.value);

                                const selected = realCycle?.find(x => x._id === e.value);

                                if (selected) {
                                  setCycleSelected({
                                    _id: selected._id,
                                    title: selected.title,
                                    version: GetVersion(selected.date_start),
                                  });
                                }
                              }}
                              value={
                                optionsCycle.find(x => x.value === cycleSelected?._id)
                                  ? optionsCycle.find(x => x.value === cycleSelected?._id)
                                  : optionsCycle[getIndexByValue(optionsCycle, activeItem)]
                              }
                            />
                          </div>
                        )}
                      </div>

                      <p className="text-white mb-8 text-base font-normal block">Escolha a fase</p>

                      <ul className="space-y-4 flex flex-col">
                        {activeStageObj?.semester_title &&
                          activeStageObj?.date_evaluation_step5_start &&
                          activeStageObj?.date_evaluation_step5_finish && (
                            <li>
                              <button
                                className={`${
                                  cycleActive === 'semestral' ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-full h-10`}
                                onClick={() => {
                                  setCycleActive('semestral');
                                }}
                              >
                                {activeStageObj?.semester_title}
                              </button>
                            </li>
                          )}

                        {activeStageObj?.trimester_title &&
                          activeStageObj?.date_evaluation_step4_start &&
                          activeStageObj?.date_evaluation_step4_finish && (
                            <li>
                              <button
                                className={`${
                                  cycleActive === 'trimestral' ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-full h-10`}
                                onClick={() => {
                                  setCycleActive('trimestral');
                                }}
                              >
                                {activeStageObj?.trimester_title}
                              </button>
                            </li>
                          )}

                        {taskCycles &&
                          taskCycles.slice(0, numberOfElements).map((cycle: any) => (
                            <li key={cycle._id}>
                              <button
                                className={`${
                                  cycleActive === cycle._id ? 'text-alice-blue bg-slate-blue' : 'text-white'
                                } text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-full h-10`}
                                onClick={() => setCycleActive(cycle._id)}
                              >
                                {cycle.title}
                                {/* {GetTaskStatusLabel(cycle.status)} */}
                              </button>
                            </li>
                          ))}

                        {taskCycles.length > 3 && (
                          <button
                            className="mt-4 mx-auto flex items-center text-grey-light justify-center lg:justify-start"
                            onClick={() => (!showMore ? setNumberOfElements(3) : setNumberOfElements(numberOfElements + 3))}
                          >
                            {!showMore ? (
                              <>
                                <BiMinus className="mr-2 inline-block grey-dark" size={17} />
                                <span className="uppercase">Ver menos</span>
                              </>
                            ) : (
                              <>
                                <BsPlusLg className="mr-2 inline-block grey-dark" size={17} />
                                <span className="uppercase">Ver mais</span>
                              </>
                            )}
                          </button>
                        )}
                      </ul>
                    </div>

                    <div className="bg-maastricht-blue rounded-3xl p-8">
                      <p className="block text-white leading-none font-normal text-base mb-4">
                        Realizações Destaque de {activeCycleObj?.title}
                      </p>

                      <ul className="flex flex-col w-full">
                        <li className="flex items-center justify-between text-white font-light text-xs leading-none mb-4 pb-4 border-b border-prussian-blue-2">
                          {tab === 'cadastrada'
                            ? 'Total de realizações cadastradas'
                            : 'Total de realizações cadastradas que você participa'}{' '}
                          <span className="text-base text-yellow leading-none font-semibold flex-1 text-right pl-2">
                            {resumePerCycle?.registered || '0'}
                          </span>
                        </li>
                        <li className="flex items-center justify-between text-white font-light text-xs leading-none mb-4 pb-4 border-b border-prussian-blue-2">
                          {tab === 'cadastrada'
                            ? 'Total de realizações validadas'
                            : 'Total de realizações validadas que você participa'}{' '}
                          <span className="text-base text-yellow leading-none font-semibold flex-1 text-right pl-2">
                            {resumePerCycle?.validated || '0'}
                          </span>
                        </li>
                        <li className="flex items-center justify-between text-white font-light text-xs leading-none">
                          {tab === 'cadastrada'
                            ? 'Total de realizações aguardando validação'
                            : 'Total de realizações aguardando validação que você participa'}{' '}
                          <span className="text-base text-yellow leading-none font-semibold flex-1 text-right pl-2">
                            {resumePerCycle?.waiting || '0'}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </>
                )}
              </Box>
            </div>

            {activeCycleObj && activeCycleObj._id !== '67203cdf2cc06079269fffc0' && (
              <div className="pt-3">
                <h2 className="text-xl text-white block mb-6 font-semibold">Calendário de validação/apreciação</h2>

                <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px]">
                  {loading ? (
                    <div className="grid grid-cols-1 gap-3">
                      <ArticlePlaceholder />
                    </div>
                  ) : (
                    <>
                      {!!activeCycleObj && (
                        <div className="bg-maastricht-blue rounded-3xl p-8 space-y-4">
                          <p className="block text-white leading-none font-normal text-base pb-2">Fase {activeCycleObj?.title}</p>

                          <div className="font-thin">
                            {cycleActive !== 'semestral' &&
                              cycleActive !== 'trimestral' &&
                              activeCycleObj?.date_evaluation_step2_start &&
                              activeCycleObj?.date_evaluation_step2_finish && (
                                <p>
                                  <span className="text-yellow font-light">
                                    {format(activeCycleObj?.date_evaluation_step2_start, 'dd/MM')} a{' '}
                                    {format(subMinutes(activeCycleObj?.date_evaluation_step2_finish, 10), 'dd/MM')}:
                                  </span>{' '}
                                  {playerInfo.mad ? (
                                    <>
                                      Validação (Líderes imediatos), Apreciação Nível 1 e Apreciação Nível 2 (Apenas até
                                      Bonificação)
                                    </>
                                  ) : (
                                    <>Validação (Líderes imediatos) e Apreciação Nível 1</>
                                  )}
                                </p>
                              )}

                            {cycleActive === 'trimestral' &&
                              activeCycleObj?.date_evaluation_step4_start &&
                              activeCycleObj?.date_evaluation_step4_finish && (
                                <p className="pt-4 border-t border-prussian-blue-2">
                                  <span className="text-yellow font-light">
                                    {format(activeCycleObj?.date_evaluation_step4_start, 'dd/MM')} a{' '}
                                    {format(subMinutes(activeCycleObj?.date_evaluation_step4_finish, 10), 'dd/MM')}:
                                  </span>{' '}
                                  {playerInfo.mad ? <>Premiação Nível 2</> : <>Apreciação Nível 2 e Prosseguir</>}
                                </p>
                              )}

                            {cycleActive === 'semestral' &&
                              activeCycleObj?.date_evaluation_step5_start &&
                              activeCycleObj?.date_evaluation_step5_finish && (
                                <p className="pt-4 border-t border-prussian-blue-2">
                                  <span className="text-yellow font-light">
                                    {format(activeCycleObj?.date_evaluation_step5_start, 'dd/MM')} a{' '}
                                    {format(subMinutes(activeCycleObj?.date_evaluation_step5_finish, 10), 'dd/MM')}:
                                  </span>{' '}
                                  Apreciação Nível 3 (Gerentes Gerais UE e Diretores)
                                </p>
                              )}
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </Box>
              </div>
            )}

            <div className="pt-3">
              <h2 className="text-xl text-white block mb-6 font-semibold">Realizações da sua unidade</h2>

              <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px]">
                {loading ? (
                  <div className="grid grid-cols-1 gap-3">
                    <ArticlePlaceholder />
                  </div>
                ) : (
                  <>
                    <div className="px-8 flex flex-col items-center">
                      <p className="mb-5">Deseja acompanhar as Realizações Destaque cadastradas pelos colegas da sua unidade?</p>

                      <button
                        className={`text-white text-sm flex items-center justify-center font-semibold uppercase ring-2 ring-slate-blue rounded w-full h-10`}
                        onClick={() => setShowDetail(true)}
                      >
                        ver realizações
                      </button>
                    </div>
                  </>
                )}
              </Box>
            </div>
          </div>

          <div className="lg:w-[64.8%]">
            <h2 className="text-xl text-white block mb-6 font-semibold">
              Realizações Destaque {activeCycleObj?.status === 'open' ? 'da fase atual' : 'de ' + activeCycleObj?.title}
            </h2>

            <Box className="relative bg-prussian-blue border-electric-blue p-4 lg:p-8 border-opacity-100 bg-opacity-100 w-full rounded-[20px] space-y-6">
              {loading ? (
                <div className="grid grid-cols-1 gap-3">
                  <ArticlePlaceholder />
                </div>
              ) : (
                <>
                  {renderCreateTaskPerCycle()}
                  {renderTasksPerCycle()}
                </>
              )}
            </Box>
          </div>
        </div>
      </div>

      <Outlet />
    </>
  );
}
